export const SOFTLINE_PERMISSION_ABAU_SALE_STATISTICS = 'SOFTAPPS.ABAU.UMSATZSTATISTIK';
